import { createFileRoute } from "@tanstack/react-router";
import { createSocialHeadMeta } from "~/lib/social-head";
import { CURRENCIES_SOCIAL_METADATA } from "~/lib/social-metadata";
import { createRwaMarketsRouteLoader } from "~/features/rwa-markets/rwa-markets-route-loader";

export const Route = createFileRoute("/_app/currencies")({
  head: () => ({
    meta: createSocialHeadMeta(CURRENCIES_SOCIAL_METADATA),
  }),
  loader: createRwaMarketsRouteLoader("currencies"),
});
